import {BaseDomainModel} from "../../../../../../infrastructure/models/base-domain-model";
import {PlayersStatisticsTableRowValueApiModel} from "./values/players-statistics.table.row.value.api-model";
import {PlayersStatisticsTableRowValueDomainModel} from "./values/players-statistics.table.row.value.domain-model";
import {PlayersStatisticsTableRowApiModel} from "./players-statistics.table.row.api-model";

export class PlayersStatisticsTableRowDomainModel extends BaseDomainModel {
  apiModel: PlayersStatisticsTableRowApiModel;

  get values(): PlayersStatisticsTableRowValueDomainModel {
    const values: PlayersStatisticsTableRowValueDomainModel = this.apiModel.values?.map((value: PlayersStatisticsTableRowValueApiModel) => new PlayersStatisticsTableRowValueDomainModel(value))

    return values;
  }
}
